// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import LendingOperationsController from "./lending_operations_controller"
application.register("lending-operations", LendingOperationsController)

import ClickableRowController from "./clickable_row_controller"
application.register("clickable-row", ClickableRowController)

import GeoAutocompleteController from "./geo_autocomplete_controller"
application.register("geo-autocomplete", GeoAutocompleteController)

import AmountInputController from "./amount_input_controller"
application.register("amount-input", AmountInputController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import SelectMultipleController from "./select_multiple_controller"
application.register("select-multiple", SelectMultipleController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import ModalCropperController from "./modal_cropper_controller"
application.register("modal-cropper", ModalCropperController)

import MultiselectAutocompleteController from "./multiselect_autocomplete_controller"
application.register("multiselect-autocomplete", MultiselectAutocompleteController)

import ButtonGroupSelectController from "./button_group_select_controller"
application.register("button-group-select", ButtonGroupSelectController)

import SupportSubcategoryController from "./support_subcategory_controller"
application.register("support-subcategory", SupportSubcategoryController)

import CollectStepsController from "./collect_steps_controller"
application.register("collect-steps", CollectStepsController)

import CollectStepPercentageController from "./collect_step_percentage_controller.js"
application.register("collect-steps-percentage", CollectStepPercentageController)

import AttachmentsController from "./attachments_controller"
application.register("attachments", AttachmentsController)
